import { useProjectGraphProductionQuery } from "@/api/graphql"
import { useProductionGraphContext } from "@/components/graphs/types/bar/ProductionGraphContext"
import { useCurrentProjectId } from "../hooks/useCurrentProjectId"

export function useProjectGraphProductionData() {
	const { graphInterval, startTime, endTime } = useProductionGraphContext()
	const projectId = useCurrentProjectId()

	return useProjectGraphProductionQuery({
		projectId: String(projectId),
		startTime: startTime,
		endTime: endTime,
		interval: graphInterval,
	})
}
